import { useGetMainSearchQuery } from '@/app/(main)/search/hooks/useGetMainSearchQuery';
import { goToSearchDetails } from '@/app/(main)/search/utils/goToSearchDetailsPath';
import { SEARCH_CATEGORIES } from '@/consts/search-const';
import type { GlobalSearchCategory, GlobalSearchToolkitItem } from '@/types/globalSearchApiTypes';
import { CategoryWrapper } from '../CategoryWrapper';
import { ToolkitItem } from '../ToolkitItem';

interface ToolkitCategoryProps {
  data: GlobalSearchCategory<GlobalSearchToolkitItem>;
}

export const ToolkitCategory = ({ data }: ToolkitCategoryProps) => {
  const { search } = useGetMainSearchQuery();

  return (
    <CategoryWrapper
      categoryName="Toolkits"
      itemsCount={data.count}
      redirectToDetails={goToSearchDetails({ category: SEARCH_CATEGORIES.TOOLKIT, searchQuery: search })}
    >
      {data.results.map((item) => (
        <ToolkitItem key={item.title} item={item} />
      ))}
    </CategoryWrapper>
  );
};